import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Module-level cache — loads once per session, shared across all components
let cachedBranding = null;
let listeners = [];

function notifyListeners() {
  listeners.forEach(fn => fn({ ...cachedBranding }));
}

export function useBranding() {
  const [branding, setBranding] = useState(
    cachedBranding || { logoUrl: null, poolName: 'March Madness Pool' }
  );

  useEffect(() => {
    const listener = b => setBranding(b);
    listeners.push(listener);

    if (!cachedBranding) {
      fetch(`${API_URL}/branding`)
        .then(r => r.json())
        .then(data => {
          cachedBranding = data;
          notifyListeners();
        })
        .catch(err => console.warn('Branding load:', err.message));
    }

    return () => { listeners = listeners.filter(l => l !== listener); };
  }, []);

  return branding;
}

// Call after saving to instantly update navbar and all consumers
export function refreshBranding(newBranding) {
  cachedBranding = { ...newBranding };
  notifyListeners();
}
